// Hands a pending build off from the homepage chat composer to the generate
// flow. A File the user attached on the landing page can't ride in a URL, so we
// stash it in module memory — the same JS context survives a client-side route
// change (no full reload) — and GenerateSkill claims it once on mount.
let pendingFile = null;

export function setPendingFile(file) {
  pendingFile = file || null;
}

export function takePendingFile() {
  const f = pendingFile;
  pendingFile = null;
  return f;
}

// ── Post-login intent ────────────────────────────────────────────────────────
// Where a gated action wants the user to end up once a session exists. Written
// by whatever sends an unauthed user to the login surface, claimed once by
// <Dashboard/> after login/signup. The key is exported from here rather than
// spelled out at each site, because a typo in one of them fails silently: the
// user signs in and lands on the dashboard wondering where their build went.
const POST_LOGIN_KEY = 'loreto_post_login_redirect';

export function setPostLoginRedirect(dest) {
  try {
    sessionStorage.setItem(POST_LOGIN_KEY, dest);
  } catch {
    /* private mode / storage disabled — the user just lands on the dashboard */
  }
}

// Read without consuming. The sign-in surface needs to know an intent is
// pending so it can show what that intent produces, but it must not clear the
// intent — <Dashboard/> claims it after login, and a peek that consumed it
// would drop the user on the generic dashboard again.
export function peekPostLoginRedirect() {
  try {
    return sessionStorage.getItem(POST_LOGIN_KEY);
  } catch {
    return null;
  }
}

export function takePostLoginRedirect() {
  try {
    const dest = sessionStorage.getItem(POST_LOGIN_KEY);
    if (dest) sessionStorage.removeItem(POST_LOGIN_KEY);
    return dest;
  } catch {
    return null;
  }
}
